import { ethers } from 'ethers';

// Network to Explorer URL mapping
const EXPLORER_URLS = {
  31337: '', // Local - no explorer
  31338: '', // DevCLI - no explorer
  80002: 'https://amoy.polygonscan.com/', // Polygon Amoy testnet
  137: 'https://polygonscan.com/', // Polygon mainnet
};

/**
 * Get the current network chain ID
 */
export const getCurrentChainId = async (provider) => {
  try {
    if (!provider) return null;
    const network = await provider.getNetwork();
    return network.chainId;
  } catch (error) {
    console.error('Failed to get chain ID:', error);
    return null;
  }
};

/**
 * Get explorer base URL for the current network
 */
export const getExplorerUrl = async (provider) => {
  const chainId = await getCurrentChainId(provider);
  return EXPLORER_URLS[chainId] || '';
};

/**
 * Generate address explorer link
 */
export const getAddressLink = async (provider, address) => {
  const explorerUrl = await getExplorerUrl(provider);
  if (!explorerUrl || !address) return null;
  return `${explorerUrl}address/${address}`;
};

/**
 * Generate transaction explorer link
 */
export const getTransactionLink = async (provider, txHash) => {
  const explorerUrl = await getExplorerUrl(provider);
  if (!explorerUrl || !txHash) return null;
  return `${explorerUrl}tx/${txHash}`;
};

/**
 * Utility to check if current network has explorer support
 */
export const hasExplorerSupport = async (provider) => {
  const explorerUrl = await getExplorerUrl(provider);
  return Boolean(explorerUrl);
};